import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '~/components/ComingSoon';

const TacticalDronesPage = () => {
  return <ComingSoon title="Tactical Drones" subtitle="Our Products" />;
};

export const Route = createFileRoute('/$locale/products/tactical-drones')({
  component: TacticalDronesPage,
});
